import React, { useMemo } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiClock } = FiIcons;

function StatusBadge({ status }) {
  const complete = status === 'completed';

  return (
    <span className={`status-badge ${complete ? 'complete' : 'active'}`}>
      <SafeIcon icon={complete ? FiCheck : FiClock} />
      {complete ? 'Completed' : 'In progress'}
    </span>
  );
}

function SessionHistory({ curriculum = [], child }) {
  const sessions = useMemo(() => (curriculum || []).flatMap((group) => (
    (group.lessons || [])
      .filter((lesson) => (
        lesson.status === 'completed' || lesson.status === 'in-progress'
      ))
      .map((lesson) => ({
        ...lesson,
        progress: Number.isFinite(Number(lesson.progress))
          ? Number(lesson.progress)
          : 0,
        subject: group.subject
      }))
  )), [curriculum]);

  const childName = child?.name || 'your child';

  return (
    <section className="history-card">
      <div className="section-heading">
        <div>
          <h2>Topic progress</h2>
          <p>A simple view of {childName}’s recent tutoring activity.</p>
        </div>
        <span className="week-label">This week</span>
      </div>

      {sessions.length === 0 ? (
        <div className="empty-state">
          <p>No activity yet</p>
          <small>
            When {childName} starts a tutoring session, progress will show up here.
          </small>
        </div>
      ) : (
        <div className="session-list">
          {sessions.map((session) => (
            <article className="session-row" key={session.id}>
              <div className="session-topic">
                <span className="subject-code">{session.subject.slice(0, 1)}</span>
                <div>
                  <strong>{session.title}</strong>
                  <small>
                    {session.subject}
                    {session.lastActivity ? ` · ${session.lastActivity}` : ''}
                  </small>
                </div>
              </div>

              <div className="progress-cell">
                <div className="progress-label">
                  <span>Progress</span>
                  <strong>{session.progress}%</strong>
                </div>
                <div className="progress-track">
                  <span style={{ width: `${session.progress}%` }} />
                </div>
              </div>

              <span className="duration">{session.duration || '—'}</span>
              <StatusBadge status={session.status} />
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

export default SessionHistory;
